import { useMemo, useCallback } from "react";
import { TextField, TextFieldProps } from "@mui/material";

export type InputProps = Omit<TextFieldProps, "error"> & {
  textarea?: boolean;
  hideArrows?: boolean;
  fieldLength?: number;
  allowNegative?: boolean;
  error?: any;
};

const hiddenArrowsStyle = {
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
};

export const Input = (props: InputProps) => {
  const {
    name,
    error,
    onChange,
    inputProps,
    fieldLength = 0,
    textarea = false,
    hideArrows = false,
    allowNegative = false,
    ...restProps
  } = props;

  const sx = useMemo(
    () => ({
      ...(restProps.sx ?? {}),
      ...(hideArrows ? hiddenArrowsStyle : {}),
    }),
    [hideArrows, restProps.sx]
  );

  const helperText = useMemo(() => {
    if (textarea && inputProps?.maxLength) {
      return `${fieldLength}/${inputProps?.maxLength ?? 1} characters`;
    }
    return null;
  }, [fieldLength, inputProps?.maxLength, textarea]);

  const handleKeyPress = useCallback((event: any) => {
    if (event.key === "-") {
      event.preventDefault();
    }
  }, []);

  return (
    <TextField
      sx={sx}
      name={name}
      onChange={onChange}
      error={!!error}
      data-testid={name}
      inputProps={inputProps}
      helperText={error?.message ?? helperText}
      onKeyPress={allowNegative ? handleKeyPress : undefined}
      {...restProps}
    />
  );
};
